import { createContext, useContext } from 'react';

export const ModalContext = createContext<object | undefined>(undefined);

export const useModalContext = () => useContext(ModalContext);
